import { Group, Image, Tooltip } from '@mantine/core'
import { useIntl } from 'react-intl'
import { integrationConfig } from '@/components/deployments/deployment-editor/IntegrationSelection/config'
import { EventDestination } from '@/types/deployment'

type DeploymentOutputListProps = {
  services: EventDestination[]
}

export const DeploymentOutputList = ({
  services
}: DeploymentOutputListProps) => {
  const intl = useIntl()

  return (
    <Group gap={8} wrap="nowrap" align="center">
      {services.map((service) => {
        const { logo, name } = integrationConfig[service]
        const label = intl.formatMessage({ id: name })

        return (
          <Tooltip
            key={service}
            label={label}
            events={{ hover: true, focus: true, touch: false }}
          >
            <Image
              src={logo}
              alt={label}
              tabIndex={0}
              w={16}
              h={16}
              fit="contain"
            />
          </Tooltip>
        )
      })}
    </Group>
  )
}
